import Api from "../../services/Api";
import { isValidSerialNumber, sanitizeString } from "../utils/apiValidation";

// Cache to store active promises
const inflightRequests = new Map();

function fetchSiteIdBySerial(serialNumber) {
  if (!isValidSerialNumber(serialNumber)) {
    return Promise.reject(new Error("Invalid serial number"));
  }

  const sanitizedSerial = sanitizeString(String(serialNumber));

  if (inflightRequests.has(sanitizedSerial)) {
    return inflightRequests.get(sanitizedSerial);
  }

  const requestPromise = Api.post("/service/iqevse-csms/charger/v1/query/ev_charger", {
    is: { serialNumber: sanitizedSerial, isRetired: false },
  }).finally(() => {
    inflightRequests.delete(sanitizedSerial);
  });

  inflightRequests.set(sanitizedSerial, requestPromise);

  return requestPromise;
}

export { fetchSiteIdBySerial };
